<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addGroup"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة مجموعة جديد
            </button>

            <!-- Add Modal Start -->
            <div
              class="modal fade"
              id="addGroup"
              tabindex="-1"
              aria-labelledby="addGroupLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة مجموعة</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form id="addGroup" @submit.prevent="addNewGroup($event)">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="groupName">اسم المجموعة</label>
                            <input
                              type="text"
                              id="groupName"
                              class="form-control"
                              placeholder="اسم المجموعة"
                              v-model="group.group_name"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label for="groupDescription">وصف المجموعة</label>
                            <textarea
                              id="groupDescription"
                              cols="30"
                              rows="5"
                              class="form-control"
                              placeholder="وصف المجموعة"
                              v-model="group.group_description"
                            ></textarea>
                          </div>
                        </div>

                        <!-- Buttons -->
                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button type="submit" class="btn add w-100">
                              أضافة
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>

            <table v-show="this.groups.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th class="fit" scope="col">الرقم</th>
                  <th scope="col">اسم المجموعة</th>
                  <th scope="col">الوصف</th>
                  <th scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(group, index) in this.groups" :key="index">
                  <th>{{ index + 1 }}</th>
                  <td>{{ group.group_name }}</td>
                  <td>{{ group.group_description }}</td>
                  <td>
                    <router-link
                      class="btn me-2 add"
                      :to="{
                        name: 'groupDetails',
                        params: { id: group.group_id },
                      }"
                    >
                      <i class="fas fa-building ms-2"></i>
                      فصول
                    </router-link>

                    <!-- Delete Button -->
                    <button
                      class="btn me-2 edit"
                      data-bs-toggle="modal"
                      data-bs-target="#EditGroup"
                      @click="getGroupById(group.group_id)"
                    >
                      <i class="fas fa-edit ms-2"></i>
                      تعديل
                    </button>
                    <!-- Add Modal Start -->
                    <div
                      class="modal fade"
                      id="EditGroup"
                      tabindex="-1"
                      aria-labelledby="EditGroupLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">تعديل مجموعة</h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              @click="this.clearData()"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <form
                              id="EditGroup"
                              @submit.prevent="editSelectedGroup($event)"
                            >
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="groupName">اسم المجموعة</label>
                                    <input
                                      type="text"
                                      id="groupName"
                                      class="form-control"
                                      placeholder="اسم المجموعة"
                                      v-model="updateGroup.group_name"
                                      required
                                    />
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="groupDescription"
                                      >وصف المجموعة</label
                                    >
                                    <textarea
                                      id="groupDescription"
                                      cols="30"
                                      rows="5"
                                      class="form-control"
                                      placeholder="وصف المجموعة"
                                      v-model="updateGroup.group_description"
                                    ></textarea>
                                  </div>
                                </div>

                                <!-- Buttons -->
                                <div class="col-12">
                                  <div class="form-group text-start mt-4">
                                    <button
                                      type="submit"
                                      class="btn edit w-100"
                                    >
                                      تعديل
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Delete Button -->
                    <button
                      class="btn me-2 delete"
                      @click="deleteSelectedGroup(group.group_id)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.groups) || this.groups.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد مجموعات حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";

export default {
  data() {
    return {
      // Loading
      isloading: true,
      isfirstLoad: true,
      //
      currentView: "المجموعة",
      groups: [],
      updateGroup: {},
      group: {
        group_name: "",
        group_description: "",
      },
      // Search
      searchValue: "",
    };
  },
  methods: {
    ...mapActions("groupsModule", [
      "fetchGroups",
      "addGroup",
      "getGroupById",
      "updateGroupSelected",
      "deleteGroup",
    ]),
    //-----------------------------------------------

    // Sort
    sortByCreateDate() {
      this.groups.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.groups.sort((a, b) => (a.group_name < b.group_name ? -1 : 1));
    },

    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.groups = this.getGroups.filter(
          (item) => item.group_name.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------

    // Basic Button In Table
    async getAllGroups() {
      this.groups = await this.fetchGroups();
    },

    async addNewGroup(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      await this.addGroup(this.group);

      closeButton.click();
      this.clearAndShowSuccess("تم الإضافة بنجاح");
    },

    async getSelectedGroup(id) {
      this.updateGroup = await this.getGroupById(id);
    },
    // edit Group
    editSelectedGroup(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      this.updateGroupSelected(this.updateGroup);
      closeButton.click();

      this.clearAndShowSuccess("تم تعديل المجموعة بنجاح");
    },
    // Delete Group
    deleteSelectedGroup(id) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذه المجموعة؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف المجموعة بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteGroup(id);
        }
      });
    },
    // ---------------------------------------------------
    // Default Functions
    // Clear Input and Messages me Success
    clearAndShowSuccess(message) {
      this.successAdd(message);
      this.clearData();
    },
    // Toast Seccuss Message
    successAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Clear Data
    clearData() {
      this.group = {
        group_name: "",
        group_description: "",
      };
    },
  },
  async created() {
    if (this.isGroupFirstLoad) await this.getAllGroups();
    console.log(this.groups);
  },
  computed: {
    ...mapGetters("groupsModule", [
      "getGroups",
      "isLoading",
      "isGroupFirstLoad",
      "getUpdateGroup",
    ]),
  },
  mounted() {
    this.groups = this.getGroups;
    this.isloading = this.isLoading;
    this.isfirstLoad = this.isGroupFirstLoad;
    this.updateGroup = this.getUpdateGroup;
  },
  watch: {
    getGroups() {
      this.groups = this.getGroups;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isGroupFirstLoad() {
      this.isfirstLoad = this.isGroupFirstLoad;
    },
    getUpdateGroup() {
      this.updateGroup = this.getUpdateGroup;
    },
  },
};
</script>

<style>
</style>